import { Component, EventEmitter, input, isDevMode, Output } from '@angular/core';
import { MatChip } from "@angular/material/chips";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { CommentModel, commentStatus } from '../../../core/models/comment-model';
import { CheckStatus } from '../../../core/models/checks-model';
import { MatIcon } from "@angular/material/icon";
import { MatButtonModule, MatIconButton } from "@angular/material/button";
import { FormsModule } from '@angular/forms';
import { User } from '../../../core/models/user-model';
import { MatTooltip } from "@angular/material/tooltip";


@Component({
  selector: 'app-comment-component',
  imports: [MatChip, MatSlideToggle, MatIcon, MatButtonModule, MatIconButton, FormsModule, MatTooltip],
  templateUrl: './comment-component.html',
  styleUrl: './comment-component.scss',
})
export class CommentComponent {
  // Inputs von Parent-Komponente
  readonly comments = input.required<CommentModel[]>();
  readonly currentUser = input<User | null>(null);
  readonly currentCheckStatus = input<CheckStatus | null | undefined>(null);
  readonly isReadOnly = input<boolean>(false);

  readonly commentStatus = commentStatus;

  // Outputs – Mutationen werden an die Parent-Komponente delegiert
  @Output() doneToggled     = new EventEmitter<{ guid: string; isDone: boolean }>();
  @Output() severityToggled = new EventEmitter<{ guid: string; severity: string }>();
  @Output() commentDeleted  = new EventEmitter<string>();

  isAuthor(comment: CommentModel): boolean {
    return comment.author?.oid === this.currentUser()?.oid;
  }

  canDelete(comment: CommentModel): boolean {
    return this.isAuthor(comment) &&
           comment.checkStatus === this.currentCheckStatus();
  }

  toggleInfoStatus(comment: CommentModel): void {
    const newSeverity = comment.status === commentStatus.info ? 'WARNING' : 'INFO';
    this.severityToggled.emit({ guid: comment.id, severity: newSeverity });
  }

  toggleChanged(comment: CommentModel, sliderChecked: boolean): void {
    this.doneToggled.emit({ guid: comment.id, isDone: sliderChecked });
  }

  deleteComment(id: string): void {
    this.commentDeleted.emit(id);
  }
}
